<template>
    <UApp :locale="uiLocale">
        <component :is="layout">
            <router-view />
        </component>
    </UApp>
</template>

<script lang="ts" setup>
    import { computed } from 'vue'
    import { useRoute } from 'vue-router'
    import { useI18n } from 'vue-i18n'
    import * as locales from '@nuxt/ui/locale'

    import Page  from '@/layouts/Page.vue'
    import Blank from '@/layouts/Blank.vue'

    const route = useRoute()
    const { locale } = useI18n()

    // Keep Nuxt UI's built-in component texts in sync with the vue-i18n locale.
    // Fall back to English if the locale is not shipped by @nuxt/ui/locale.
    const uiLocale = computed(() => (locales as Record<string, typeof locales.en>)[locale.value] ?? locales.en)

    // The ID portal has no menu: `Blank` for the unauthenticated screens and `Page` (the
    // single-page layout, vue-spec `structure.md`) for `/settings`. No sidebar shell.
    const layouts = { Page, Blank }
    const layout  = computed(() => layouts[(route.meta.layout as keyof typeof layouts) ?? 'Page'])
</script>
